import { MapPin, Phone, Clock } from "lucide-react";
import { WhatsAppIcon } from "./FloatingButtons";
import { BRAND, NAV_LINKS, waLink, telLink } from "@/data/content";
import { scrollToSection } from "@/hooks/useLenis";

const MAP_SRC =
  "https://www.google.com/maps?q=Rua+Curuena,+212,+Ch%C3%A1cara+Belenzinho,+S%C3%A3o+Paulo+-+SP,+03380-160&output=embed";

export const Footer = () => {
  return (
    <footer id="contato" data-testid="site-footer" className="bg-[#0a0a0a] pt-20">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-[1.1fr_0.7fr_1.2fr]">
          {/* Brand + contact */}
          <div>
            <div className="flex items-center">
              <img src={BRAND.logo} alt="K2 Guincho 24h - Guincho 24 horas em São Paulo" className="h-16 w-auto" />
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-zinc-400">
              Especialistas em remoção de veículos leves e motocicletas.
              Atendimento rápido, seguro e disponível 24 horas em São Paulo.
            </p>
            <div className="mt-6 space-y-3 text-sm text-zinc-300">
              <p className="flex items-start gap-3">
                <MapPin size={17} className="mt-0.5 shrink-0 text-[#D50000]" />
                <span>
                  {BRAND.address.street}<br />
                  {BRAND.address.district}<br />
                  {BRAND.address.city} · {BRAND.address.cep}
                </span>
              </p>
              <a href={telLink} className="flex items-center gap-3 hover:text-white">
                <Phone size={17} className="text-[#D50000]" /> {BRAND.phoneDisplay}
              </a>
              <p className="flex items-center gap-3">
                <Clock size={17} className="text-[#D50000]" /> Aberto 24 horas · Todos os dias
              </p>
            </div>
            <a
              data-testid="footer-whatsapp-btn"
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-3 bg-[#25D366] px-6 py-3 text-sm font-bold uppercase tracking-wider text-black transition-colors duration-200 hover:bg-[#1EBE57]"
            >
              <WhatsAppIcon size={18} /> {BRAND.phoneDisplay}
            </a>
          </div>

          {/* Quick links */}
          <div>
            <h3 className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#FF4444]">
              Links Rápidos
            </h3>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    data-testid={`footer-link-${l.href.replace("#", "")}`}
                    onClick={() => scrollToSection(l.href)}
                    className="font-display text-lg uppercase tracking-tight text-zinc-400 transition-colors duration-200 hover:text-white"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Map */}
          <div>
            <h3 className="font-mono-t text-xs uppercase tracking-[0.25em] text-[#FF4444]">
              Como Chegar
            </h3>
            <div className="mt-5 overflow-hidden border border-white/10">
              <iframe
                title="Mapa K2 Guincho 24h"
                src={MAP_SRC}
                data-testid="google-map"
                width="100%"
                height="260"
                style={{ border: 0, filter: "grayscale(1) invert(0.92) contrast(0.9)" }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-white/10 py-8 sm:flex-row">
          <p className="font-mono-t text-xs uppercase tracking-widest text-zinc-600">
            © {new Date().getFullYear()} K2 Guincho 24H — Todos os direitos reservados
          </p>
          <p className="font-mono-t text-xs uppercase tracking-widest text-zinc-600">
            Guincho 24 Horas · Zona Leste · São Paulo
          </p>
        </div>
      </div>
    </footer>
  );
};
